export const PRODUCT_OPTIONS_URL = '/api/v1/configuration/customise-product-options/'
export const GET_TAX_URL = '/api/v1/configuration/tax/'
export const STORE_CHECKOUT = '/api/v1/store/checkout/'
export const STORE_VALIDATE = '/api/v1/store/validate'
